module.exports = {
  redeemed_vouchers: 'Bereits eingelöste Voucher-Codes',
  endless: 'Unbegrenzt',
  redeemed_at: 'Eingelöst: %{date}',
  redeem: 'Einlösen',
  'redeem-voucher': 'Voucher einlösen',
  please_enter_code: 'Bitte gebe einen Voucher-Code ein',
  invalid_voucher_description: 'Bitte überprüfe die Schreibweise. Wende dich an %{adminEmail} falls es weiterhin nicht klappen sollte.',
  valid_until: 'Gültig bis:',
  voucher_redeemed: 'Der Voucher wurde eingelöst.',
  voucher_failed_to_redeem: 'Dein Voucher konnte leider nicht eingelöst werden',
}
